import React from "react";
import { Form, Input, Select, Row, Col, Card, Button } from "antd";

const { Option } = Select;

const EntitasSection = ({ title }) => (
    <Card title={title} bordered={false} className="card-custom" style={{ marginBottom: 20 }}>
        <Row gutter={24}>
            <Col span={24}>
                <Form.Item label="Identitas">
                    <Row gutter={8}>
                        <Col span={6}>
                            <Select placeholder="Jenis Identitas">
                                <Option value="NPWP">NPWP 15 DIGIT</Option>
                            </Select>
                        </Col>
                        <Col span={18}>
                            <Input placeholder="Nomor Identitas" />
                        </Col>
                    </Row>
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={24}>
            <Col span={24}>
                <Form.Item label="Nama">
                    <Input placeholder="Nama Perusahaan" />
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={24}>
            <Col span={24}>
                <Form.Item label="Alamat">
                    <Input.TextArea rows={2} placeholder="Alamat Perusahaan" />
                </Form.Item>
            </Col>
        </Row>
    </Card>
);

const Entitas = ({ data, setData }) => {
    const isBC27 = data.kodeDokumen === "27";

    if (isBC27) {
        return (
            <Form layout="vertical">
                <Row gutter={24}>
                    <Col span={8}>
                        <EntitasSection title="TPB Asal Barang / Pengusaha Kena Pajak" />
                    </Col>
                    <Col span={8}>
                        <EntitasSection title="TPB Tujuan Barang / Pembeli Barang Kena Pajak" />
                    </Col>
                    <Col span={8}>
                        <EntitasSection title="Pemilik Barang" />
                    </Col>
                </Row>
            </Form>
        );
    }

    return (
        <Form layout="vertical">
            <Row gutter={24}>
                <Col span={12}>
                    <EntitasSection title="Pengusaha" />
                </Col>
                <Col span={12}>
                    <EntitasSection title="Pengusaha TPB" />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <EntitasSection title="Pemilik" />
                </Col>
            </Row>
        </Form>
    );
};

export default Entitas;
